'use client';
import { UnixTimestamp } from '@benzinga/session';
import { Sparkline } from '../../Sparkline';
import { TickerContext } from '../context';
import React from 'react';

interface Props {
  referenceTime?: UnixTimestamp;
}

export const SparkLineModule: React.FC<Props> = props => {
  const ticker = React.useContext(TickerContext);
  return <Sparkline referenceTime={props.referenceTime} symbol={ticker.symbol} updateHeight={ticker.updateHeight} />;
};
